import { State, BookingState, PatientChartInfo } from 'types';

export const getBookingInfo = (state: State): BookingState => state.booking;
export const getBookingPatientInfo = (state: State): PatientChartInfo => state.booking.patient;
